import { useContext, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import _ from 'lodash';

import {
  DossierSectionOptions,
  DossierSectionStatusOptions,
} from 'features/captains-form/slices/constants';

import { selectCargoDocumentsByTitle } from '../../../slices/documentsSlice';
import {
  createPortcallStatusLog,
  getPortcallStatusLog,
  selectCargo,
  selectGeneralData,
} from '../../../slices/portCallSlice';

import UploadDownloadBox from './UploadDownloadBox';
import { FormRefContext } from '../../../../global/context/FormRefContext';
import PageHeader from '../../../../layout/components/PageHeader';
import SkipAndNextButtons from '../../port-call-data/components/SkipAndNextButtons';

import '../styles/cargo-table.scss';
function CargoTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formRef = useRef();
  const { formContextRef } = useContext(FormRefContext);
  const params = useParams();
  const cargo = useSelector(selectCargo);

  useEffect(() => {
    formContextRef.current = formRef.current;
  }, [formContextRef, formRef, cargo]);

  const { isVesselCarryingCargo } = useSelector(selectGeneralData);
  const cargoDocumentsByTitle = useSelector(selectCargoDocumentsByTitle);
  const shouldProvideDocuments = !_.isEmpty(cargoDocumentsByTitle);
  const noCargoDocMessage = 'No need to upload any document in this section.';

  const onSubmitClick = async () => {
    const isSuccessUpdateStatus = await dispatch(
      createPortcallStatusLog({
        statusLog: {
          uid: params.uid,
          section: DossierSectionOptions.GeneralDeclarationCargoInformation,
          status: DossierSectionStatusOptions.SubmittedToNmap,
        },
      })
    ).then((response) => {
      if (response.type && response.type.endsWith('/rejected')) return false;
      else return true;
    });
    if (!isSuccessUpdateStatus) return;

    dispatch(getPortcallStatusLog(params.uid));

    navigate(`/${params.uid}/dangerous-goods`);
  };
  const cargoDocSubtitle = () => {
    return shouldProvideDocuments ? '' : noCargoDocMessage;
  };

  function renderDocuments() {
    if (!_.isEmpty(cargoDocumentsByTitle)) {
      return Object.keys(cargoDocumentsByTitle).map((title, i) => (
        <div key={`doc-category-${i}`}>
          <div className="documents-list">
            {cargoDocumentsByTitle[title].map((document, i) => (
              <UploadDownloadBox
                key={`doc-${i}`}
                document={document}
                category="cargoDocuments"
                templateUid={document.templateUid}
                documentUid={document.documentUid}>
                {document.documentType.name}
              </UploadDownloadBox>
            ))}
          </div>
        </div>
      ));
    }
  }

  return (
    <div className="cargo-table">
      <PageHeader title={'Cargo - General information'} />
      {isVesselCarryingCargo ? (
        <div className="cargo-documents">
          <h4 style={{ margin: '18px 0' }}>Cargo documents</h4>
          <p>{cargoDocSubtitle()}</p>
          {renderDocuments()}
        </div>
      ) : (
        <p>{noCargoDocMessage}</p>
      )}
      <SkipAndNextButtons
        onSubmitClick={onSubmitClick}
        next={`/${params.uid}/dangerous-goods`}
        back={`/${params.uid}/cargo/information`}
      />
    </div>
  );
}

export default CargoTable;
